@if (comodosVistoria.length > 0) {
  <p-accordion [multiple]="true">
    @for (comodo of comodosVistoria; track trackPorIndice(ci); let ci = $index) {
      <p-accordion-panel [value]="ci">
        <p-accordion-header>
          <div class="comodo-cabecalho">
            @if (editarModelo) {
              <p-floatLabel variant="on" class="comodo-tipo-comodo-field"
                (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                <input pInputText [id]="'comodoTipoComodo' + ci" class="comodo-tipo-comodo-input" [(ngModel)]="comodo.tipo" />
                <label [for]="'comodoTipoComodo' + ci">Tipo</label>
              </p-floatLabel>
            }
            <p-floatLabel variant="on" class="comodo-nome-comodo-field"
              (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <input pInputText [id]="'comodoNomeComodo' + ci" class="comodo-nome-comodo-input" [(ngModel)]="comodo.nome" />
              <label [for]="'comodoNomeComodo' + ci">{{ editarModelo ? 'Nome' : (comodo.tipo || 'Cômodo') }}</label>
            </p-floatLabel>
            <button mat-icon-button matTooltip="Remover cômodo" class="btn-remover-comodo"
              (mousedown)="$event.stopPropagation()" (click)="confirmarRemocao(comodo); $event.stopPropagation()">
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <app-itens-comodo-vistoria [itensVistoria]="comodo.itens" [itensModelo]="comodo.itensModelo" [poolItensModelo]="itensModelo"
          [vistoriaId]="vistoriaId" [editarModelo]="editarModelo"></app-itens-comodo-vistoria>
        </p-accordion-content>
      </p-accordion-panel>
    }
  </p-accordion>
}

@if (comodosVistoria.length === 0) {
  <p class="sem-comodos">Nenhum cômodo adicionado ainda.</p>
}

<div class="adicionar-comodo">
  @if (comodosModelo.length > 0) {
    <app-generic-autocomplete
      class="select-comodo-modelo"
      [items]="comodosModelo"
      displayField="nome"
      label="Selecionar cômodo do modelo"
      inputId="comodoModeloSelecionado"
      [ngModel]="null"
      (selectionChange)="adicionarComodo($event)">
    </app-generic-autocomplete>
  }
  <button mat-stroked-button type="button" (click)="adicionarComodoAvulso()">
    <i class="pi pi-plus"></i> Adicionar cômodo avulso
  </button>
</div>
